import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

// Carte Boussole Impact pour Mon matin : décisions à valider, révisions échues, leçons récentes.
export function BoussoleCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/boussole/summary").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  return (
    <Link to="/app/standard-qualite" className="block rounded-2xl border border-[#C9A961]/30 bg-[#C9A961]/5 p-4 hover:bg-[#C9A961]/10 transition-colors" data-testid="mm-boussole-card">
      <div className="flex items-center gap-2 mb-1"><span className="text-lg">🧭</span><h3 className="font-semibold text-sm">Boussole Impact</h3>
        <span className="ml-auto text-xs text-zinc-400">{s.total} check(s)</span></div>
      <div className="flex gap-4 text-xs">
        <span className={s.to_validate ? "text-rose-300 font-semibold" : "text-zinc-500"} data-testid="mm-boussole-validate">{s.to_validate} à valider</span>
        <span className={s.to_review ? "text-amber-300 font-semibold" : "text-zinc-500"} data-testid="mm-boussole-review">{s.to_review} révision(s) échue(s)</span>
        <span className={s.decisions_to_review ? "text-amber-300 font-semibold" : "text-zinc-500"} data-testid="mm-boussole-decisions">{s.decisions_to_review || 0} décision(s) à réviser</span>
      </div>
      {(s.decisions_due || []).slice(0, 2).map((i) => <p key={i.id} className="text-[11px] text-amber-200 mt-1 truncate">📜 {i.title} · révision {i.review_date}</p>)}
      {s.items.slice(0, 3).map((i) => <p key={i.id} className="text-[11px] text-zinc-300 mt-1 truncate">• {i.title}</p>)}
      {s.recent_lessons[0] && <p className="text-[11px] text-emerald-300 mt-1 italic truncate">Leçon : {s.recent_lessons[0].lesson}</p>}
      {!s.total && <p className="text-[11px] text-zinc-500 mt-1">Fais un Check rapide avant ta prochaine décision.</p>}
    </Link>
  );
}
